module.exports = __webpack_public_path__ + "img/hubbel_logo.69994fe0.svg";